/**
 * Родительский класс всех фильтров и логических блоков
 */
export default class FilterBlock {
    constructor() {
        if (new.target === FilterBlock) {
            throw new TypeError("Cannot construct FilterBlock instances directly");
        }
    }
}
